import { useState, useEffect } from 'react'
import { PurchaseProgressProps } from './interfaces'
import { FuelProgressBar, FuelTypography } from '@frete.com/fuel-react'
import { FuelFlex } from '@frete.com/fuel-station-react'
import { useTranslator } from '~hooks'

const LOADING_PROGRESS_BREAK_REQUEST_TIME = 95
const FULL_PROGRESS = 100

function PurchaseProgress({ isLoading, handleProgress }: PurchaseProgressProps) {
  const [progress, setProgress] = useState<number>(0)
  const { k, t } = useTranslator()

  useEffect(() => {
    let interval: NodeJS.Timeout

    if (isLoading) {
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= LOADING_PROGRESS_BREAK_REQUEST_TIME) {
            clearInterval(interval)
            return prevProgress
          }
          return Math.min(prevProgress + 1, LOADING_PROGRESS_BREAK_REQUEST_TIME)
        })
      }, 25)
    } else {
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= FULL_PROGRESS) {
            clearInterval(interval)
            return FULL_PROGRESS
          }

          return Math.min(prevProgress + 5, FULL_PROGRESS)
        })
      }, 25)
    }

    return () => clearInterval(interval)
  }, [isLoading])

  useEffect(() => {
    if (progress === FULL_PROGRESS) {
      const timeout = setTimeout(() => {
        handleProgress()
      }, 250)

      return () => clearTimeout(timeout)
    }
  }, [progress, handleProgress])

  return (
    <FuelFlex
      testId='purchase-progress'
      defaultProps={{
        flexDirection: 'column',
        width: '100%',
        gap: 'km8',
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <FuelTypography size="heading-lg" weight="bold">
        {t(k.translation.RELEASING_PURCHASE)}
      </FuelTypography>
      <FuelProgressBar value={progress} data-testid='fuel-progress-bar' />
    </FuelFlex>
  )
}

export default PurchaseProgress
